// src/App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Sidebar from './pages/Sidebar';
import Relationclient from './pages/Relationclient';
import Fournisseur from './pages/Fournisseur';
import Commandeclient from './pages/Commandeclient';
import Tache from './pages/Taches';
import Donneitem from './pages/Donneitem';
import Stock from './pages/Stock';
import Fichearticle from './pages/Fichearticle';
import './App.css';
import Approvisionnement from './pages/Approvisionnement';
import Reception from './pages/Reception';
import Preparationexpedition from './pages/Preparationexpedition';
import Suiviprevision from './pages/Suiviprevision';
import Gestiondesstocks from './pages/Gestiondesstocks';
import Analysefaisabilite from './pages/Analysefaisabilite';
import Productionnomenclature from './pages/Productionnomenclature';
import Cashmanagment from './pages/Cashmanagment';
import Animation from './pages/Animation';
import Stockprojete from './pages/Stockprojete';
import Dragdrop from './pages/Dragdrop';
import Gestiondesdroits from './pages/Gestiondesdroits';
import Setpassword from './pages/Setpassword';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
  () => !!localStorage.getItem('user')
);
const [user, setUser] = useState(
  () => JSON.parse(localStorage.getItem('user') || 'null')
);

const handleLogout = () => {
  setIsAuthenticated(false);
  setUser(null);
  localStorage.removeItem('user');
};

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        onLogout={handleLogout}
        setIsAuthenticated={setIsAuthenticated}
        user={user}
        setUser={setUser}
      />
    </Router>
  );
};

const AppContent = ({ isAuthenticated, onLogout, setIsAuthenticated, user, setUser }) => {
  const location = useLocation();
  const showSidebar = isAuthenticated && location.pathname !== '/login';
  const sidebarWidth = showSidebar ? '250px' : '0';

  // Rôles autorisés pour les pages Admin + Manager protégées par rôle
  const isAdminOuManager = ['Admin', 'Manager'].includes(user?.role);

  return (
    <div style={{ display: 'flex' }}>
      {showSidebar && <Sidebar onLogout={onLogout} user={user} />}
      <div style={{ flex: 1, marginLeft: sidebarWidth }}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />

          {/* Page publique — accessible sans être connecté */}
          <Route path="/Setpassword" element={<Setpassword />} />

          {/* Login — reçoit setUser pour stocker le user connecté */}
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />

          {/* Pages accessibles à tous les rôles */}
          <Route path="/home"                  element={isAuthenticated ? <Home />                  : <Navigate to="/login" />} />
          <Route path="/Relationclient"        element={isAuthenticated ? <Relationclient />        : <Navigate to="/login" />} />

          {/* Pages Admin + Manager */}
          <Route path="/Reception"             element={isAuthenticated ? <Reception />             : <Navigate to="/login" />} />
          <Route path="/Preparationexpedition" element={isAuthenticated ? <Preparationexpedition /> : <Navigate to="/login" />} />
          <Route path="/fournisseur"           element={isAuthenticated ? <Fournisseur />           : <Navigate to="/login" />} />
          <Route path="/stock"                 element={isAuthenticated ? <Stock />                 : <Navigate to="/login" />} />
          <Route path="/Gestiondesstocks"      element={isAuthenticated ? <Gestiondesstocks />      : <Navigate to="/login" />} />
          <Route path="/Commandeclient"        element={isAuthenticated ? <Commandeclient />        : <Navigate to="/login" />} />
          <Route path="/Cashmanagment"         element={isAuthenticated ? <Cashmanagment />         : <Navigate to="/login" />} />
          <Route path="/Fournisseur"           element={isAuthenticated ? <Fournisseur />           : <Navigate to="/login" />} />
          <Route path="/Taches"                element={isAuthenticated ? <Tache />                 : <Navigate to="/login" />} />
          <Route path="/Suiviprevision"        element={isAuthenticated ? <Suiviprevision />        : <Navigate to="/login" />} />
          <Route path="/Fichearticle"          element={isAuthenticated ? <Fichearticle />          : <Navigate to="/login" />} />
          <Route path="/Donneitem"             element={isAuthenticated ? <Donneitem />             : <Navigate to="/login" />} />
          <Route path="/Approvisionnement"     element={isAuthenticated ? <Approvisionnement />     : <Navigate to="/login" />} />
          <Route path="/Analysefaisabilite"    element={isAuthenticated ? <Analysefaisabilite />    : <Navigate to="/login" />} />
          <Route path="/Productionnomenclature" element={isAuthenticated && isAdminOuManager ? <Productionnomenclature /> : <Navigate to="/login" />} />
          <Route path="/Animation"             element={isAuthenticated ? <Animation />             : <Navigate to="/login" />} />
          <Route path="/Stockprojete"          element={isAuthenticated ? <Stockprojete />          : <Navigate to="/login" />} />
          <Route path="/Dragdrop"              element={isAuthenticated ? <Dragdrop />              : <Navigate to="/login" />} />

          {/* Page Admin uniquement */}
          <Route path="/Gestiondesdroits"      element={isAuthenticated && user?.role === 'Admin' ? <Gestiondesdroits /> : <Navigate to="/login" />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;